import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.footerSection}>
          <h3 className={styles.footerLogo}>Talk2Board AI</h3>
          <p>&copy; {new Date().getFullYear()} Talk2Board AI. All rights reserved.</p>
        </div>
        <div className={styles.footerSection}>
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
            <li><Link to="/privacy">Privacy Policy</Link></li> {/* Add this page later */}
          </ul>
        </div>
        <div className={styles.footerSection}>
          <h4>Connect With Us</h4>
          <ul>
            <li><a href="mailto:info@talk2board.com">info@talk2board.com</a></li>
            <li><a href="https://linkedin.com/company/talk2boardai" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
            {/* Add other social links if desired */}
          </ul>
        </div>
      </div>
    </footer>
  );
}

export default Footer;